import { crudActions, DatasetTableConfig, TableConfigBuilder, textColumn } from '@ui';

import { CaseCategoriesModel } from '@models/case-categories.model';

export function createCategoriesTableConfig(): DatasetTableConfig<CaseCategoriesModel.CategoryWithStringRetention> {
  return new TableConfigBuilder<CaseCategoriesModel.CategoryWithStringRetention>()
    .columns([
      textColumn<CaseCategoriesModel.CategoryWithStringRetention>('name', 'CASE_CATEGORIES.TABLE.NAME', {
        width: 'minmax(150px, 1fr)',
        mobileVisible: true,
      }),
      textColumn<CaseCategoriesModel.CategoryWithStringRetention>('retentionPeriod', 'CASE_CATEGORIES.TABLE.PERIOD', {
        width: 'minmax(150px, 1fr)',
        mobileVisible: true,
      }),
    ])
    .actions(crudActions<CaseCategoriesModel.CategoryWithStringRetention>())
    .defaultRowAction('edit')
    .trackBy('_id')
    .rowHeight(52)
    .build();
}
